export enum MeanStressCorrection {
  NONE = 'NONE',
  GOODMAN = 'GOODMAN',
  GERBER = 'GERBER',
}
